import { CurrentDown } from "../../../data";
import { getDictPhrase } from "../../getDictPhrase";
export const getAmericanFootballAdditionalData = (additionalScores, participants, dict) => {
    let currentDown = additionalScores["americanFootballCurrentDown"];
    let yardsToGo = additionalScores["americanFootballYardsToGo"];
    let side = additionalScores["americanFootballPosession"];
    let yardLine = additionalScores["americanFootballYardLine"];
    const separator = getDictPhrase(dict, "AmericanFootballDataSeparator");
    if (!isDataComplete(currentDown, yardsToGo, side, yardLine)) {
        return undefined;
    }
    currentDown = getDictPhrase(dict, currentDownMap[currentDown]);
    yardsToGo = parseInt(yardsToGo) > 0 ? yardsToGo : "";
    side = getSide(side, participants);
    yardLine = parseInt(yardLine) > 0 ? yardLine : "";
    if (isJustBeforeGoalLine(yardLine)) {
        yardsToGo = getDictPhrase(dict, "Goal");
    }
    if (isDataComplete(currentDown, yardsToGo, side, yardLine)) {
        return {
            currentDown,
            yardsToGo,
            side,
            yardLine,
            separator
        };
    }
    return undefined;
};
const currentDownMap = {
    1: CurrentDown.FirstDown,
    2: CurrentDown.SecondDown,
    3: CurrentDown.ThirdDown,
    4: CurrentDown.FourthDown
};
const isDataComplete = (currentDown, yardsToGo, side, yardLine) => {
    return (currentDown && yardsToGo && side && yardLine);
};
const getSide = (posession, participants) => {
    let side = "";
    if (posession.includes("T1")) {
        side = participants[0].metadata.shortName;
    }
    else if (posession.includes("T2")) {
        side = participants[1].metadata.shortName;
    }
    return side;
};
const isJustBeforeGoalLine = (yardLine) => {
    const yardLineNum = parseInt(yardLine);
    return yardLineNum >= 0 && yardLineNum <= 10;
};
//# sourceMappingURL=getAmericanFootballAdditionalData.js.map